import { useEnquiryContext } from 'pages/Enquiry/context';
import { useCallback, useMemo } from 'react';
import {
  generatePath,
  matchPath,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { BACK_URLS } from './constants';

export interface BackStepButtonHook {
  show: boolean;
  onClick: () => void;
}

export default function useBackStepButton(): BackStepButtonHook {
  const { pathname } = useLocation();
  const { push } = useHistory();
  const { id } = useEnquiryContext();

  const show = useMemo(() => {
    const keys = Object.keys(BACK_URLS);
    const pathInKeys = keys.map((url) =>
      Boolean(
        matchPath(pathname, {
          path: url,
          exact: true,
          strict: false,
        }),
      ),
    );
    return pathInKeys.some((val) => val === true);
  }, [pathname]);

  const onClick = useCallback(() => {
    if (!id) return;
    const keys = Object.keys(BACK_URLS);
    const backUrlMatch = keys
      .map((url) =>
        matchPath(pathname, {
          path: url,
          exact: true,
          strict: false,
        }),
      )
      .filter(Boolean)?.[0];
    if (!backUrlMatch) return;
    const backUrl = BACK_URLS?.[backUrlMatch.path];
    if (!backUrl) return;
    push(generatePath(backUrl, { id }));
  }, [id, pathname, push]);

  return {
    show,
    onClick,
  };
}
